import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=c604e7d0&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=ts"
export * from "./EventEdit.vue?vue&type=script&lang=ts"
import style0 from "./EventEdit.vue?vue&type=style&index=0&id=c604e7d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c604e7d0",
  null
  
)

export default component.exports